import React from "react";
import { Button } from "react-bootstrap";
import "./locationcard.scss"
import { HeartPlusIcon, RightArrowLine, RightArrowLineDimmed } from "shared/assets/icons";
function LocationCard({ locationData, isFav, addFav, getProfileImage,navigate }) {
    return (
        <div className="locationcard">
            <div className="borderview">
                    <div className=" d-flex flex-column align-items-center justify-content-center text-center">
                        <div className={`head ${locationData.salecount > 0 ? "text-secondary":"text-inactive"}`} aria-label={locationData.title} title={locationData.title}>{locationData.title}</div>
                        <div className={`sub ${locationData.salecount > 0 ? "text-secondary":"text-inactive"}`}>{locationData.state}</div>
                    </div>
                    <div className=" d-flex flex-column align-items-center justify-content-center">
                        <div className="image-container">
                        <img className="location-image" src={getProfileImage} alt={`location image ID:- ${locationData.id}`}></img>
                        </div>
                    </div>
                    <div className="">
                        <div className=" d-flex flex-column align-items-center justify-content-center">
                            <div className={`sub-head ${locationData.salecount > 0 ? "text-secondary":"text-inactive"}`}>{locationData.contactname}</div>
                            <div className={`sub-text ${locationData.salecount > 0 ? "text-secondary":"text-dimmed"}`}>{locationData.salecount ? locationData.salecount : 0} Active Sale(s)</div>
                        </div>
                        <div className=" d-flex flex-column align-items-center justify-content-center mt-3 mb-2">
                            <div className="contact"><a href={`tel:+${locationData.phone}`}>{locationData.phone}</a> | <span className="clickable linkview" role={"button"} onClick={()=>{ 
                                let url = locationData?.website
                                  const reformat = url.includes('http') ? url : 'http://' + url;
                                  const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
                                  if (newWindow) newWindow.opener = null;
                            }}>Visit Website</span></div>
                            <div className="contact mt-2"><a href={`mailto:${locationData.email}`}>{locationData.email}</a></div>
                        </div>
                        <div className="d-flex align-items-center gap3">
                            <Button className={`${isFav ? 'btn-secondary' : 'btn-white'} rounded border-secondary border-2 heart-resp`}
                                onClick={() => { addFav() }} style={{ border: "1px solid" }} aria-label="heart-icon">{HeartPlusIcon}
                            </Button>

                        <Button className=' w-100 btn-grey rounded text-bold estate-resp d-flex gap-2 justify-content-center align-items-center' onClick={() => { navigate() }}>
                            <div>View Estate Sales</div>
                            <div > {RightArrowLine}</div>
                        </Button>
                        </div>
                    </div>
            </div>

        </div>

    )

}
export default LocationCard;